module.exports = __webpack_public_path__ + "static/media/Mario_Alberto_Agraz.1610d495.jpg";